/* Native details supplies the menu without JavaScript; enhance dismissal only. */
if (!customElements.get('schuco-products-menu')) {
  customElements.define('schuco-products-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const details = this.querySelector('details');
      if (!details) return;
      const panel = details.querySelector('.schuco-products__panel');
      if (panel && !details.classList.contains('schuco-products--drawer')) {
        const fitPanel = () => {
          if (!details.open) return;
          const available = Math.max(0, window.innerHeight - panel.getBoundingClientRect().top - 16);
          panel.style.setProperty('--schuco-menu-available', `${available}px`);
        };
        details.addEventListener('toggle', fitPanel, { signal });
        window.addEventListener('resize', fitPanel, { signal, passive: true });
        document.addEventListener('header:scrolled', fitPanel, { signal });
      }
      const close = () => { details.open = false; };
      document.addEventListener('pointerdown', (event) => {
        if (details.open && !this.contains(event.target)) close();
      }, { signal, passive: true });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          this.dismissedWithEscape = true;
          close();
          details.querySelector('summary')?.focus();
        }
      }, { signal });
      // The outer theme drawer listens on keyup. One Escape closes Products first.
      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' && this.dismissedWithEscape) {
          event.preventDefault();
          event.stopPropagation();
          this.dismissedWithEscape = false;
        }
      }, { signal });
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
